<div class="form-container" [formGroup]="firstFormGroup" *ngIf="popupType == 1">
    <div fxLayout="column" style="height: 100%;">
        <!-- Header -->
        <div fxLayout="row" fxLayoutAlign="space-between center" class="header-row" fxFlex="10">
            <div fxFlex="auto" class="header-text">
                Update Lead
            </div>
            <div fxFlex="none">
                <mat-icon (click)="callclosepopup()" style="cursor:pointer;">close</mat-icon>
            </div>
        </div>
        <div fxFlex="10">

        </div>
        <div fxFlex="60" class="formfield">

            <div fxLayout="row" fxLayoutAlign="start center" class="field-row">
                <div fxFlex="10" class="col-10">
                    <mat-icon class="iconcss" style="margin-bottom: 20px;">star_border</mat-icon>
                </div>
                <div fxFlex="70" class="col-70">
                    <mat-form-field appearance="outline" style="width: 100%;">
                        <mat-label>Name</mat-label>
                        <input [attr.guide]="'popup-leadstatus-inp-name-1' + '__' + sanitizeUrl(url)" matInput formControlName="Name"
                            [placeholder]="editModeName ? 'Enter Name' : LeadDetailsObject?.name"/>
                    </mat-form-field>
                </div>
                <div fxFlex="20" class="col-20">
                    <!-- <mat-icon class="iconcss" (click)="toggleEditMode('Name')" style="margin-bottom: 28px;">edit</mat-icon> -->
                </div>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" class="field-row">
                <div fxFlex="10" class="col-10">
                    <mat-icon class="iconcss" style="margin-bottom: 20px;">call</mat-icon>
                </div>
                <div fxFlex="70" class="col-70">
                    <mat-form-field appearance="outline" style="width: 100%;">
                        <mat-label>Phone Number</mat-label>
                        <input [attr.guide]="'popup-leadstatus-inp-phonenumber-1' + '__' + sanitizeUrl(url)" matInput formControlName="PhoneNumber"
                            [placeholder]="editModePhoneNumber ? 'Enter Phone Number' : LeadDetailsObject?.phoneNumber"
                            />
                    </mat-form-field>
                </div>
                <div fxFlex="20" class="col-20">
                    <!-- <mat-icon class="iconcss" (click)="toggleEditMode('PhoneNumber')"  style="margin-bottom: 28px;">edit</mat-icon> -->
                </div>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" class="field-row">
                <div fxFlex="10" class="col-10">
                    <mat-icon class="iconcss" style="margin-bottom: 20px;">call</mat-icon>
                </div>
                <div fxFlex="70" class="col-70">
                    <mat-form-field appearance="outline" style="width: 100%;">
                        <mat-label>Secondary Phone Number</mat-label>
                        <input [attr.guide]="'popup-leadstatus-inp-secondaryphoneno-1' + '__' + sanitizeUrl(url)" matInput formControlName="secondaryphoneno"
                            [placeholder]="editModePhoneNumber ? 'Enter Phone Number' : LeadDetailsObject?.secondaryphoneno"
                            />
                    </mat-form-field>
                </div>
                <div fxFlex="20" class="col-20">
                    <!-- <mat-icon class="iconcss" (click)="toggleEditMode('secondaryphoneno')"  style="margin-bottom: 28px;">edit</mat-icon> -->
                </div>
            </div>


            <div fxLayout="row" fxLayoutAlign="start center" class="field-row">
                <div fxFlex="10" class="col-10">
                    <mat-icon class="iconcss" style="margin-bottom: 20px;">thumbs_up_down</mat-icon>
                </div>
                <div fxFlex="70" class="col-70">
                    <mat-form-field appearance="outline" class="my-custom-field" style="width: 100%;" fxFlex>
                        <mat-label class="white-text">Lead Status</mat-label>
                        <mat-select class="white-text" formControlName="LeadStatus" [disableOptionCentering]="true"
                            #singleSelect autocomplete="off">
                            <mat-option>
                                <ngx-mat-select-search name="Lead Status Search" ngDefaultControl
                                    [formControl]="typeYFilterControl" placeholderLabel="Lead Status Search"
                                    [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
                                </ngx-mat-select-search>
                            </mat-option>
                            <mat-option class="white-text"
                                (onSelectionChange)="createDynamicForm($event,opt.dynamicFormGroupId,opt.statusId, opt.statusName)"
                                *ngFor="let opt of filtereddropdownTypeList; let i=index;" [value]="opt.statusId">
                                {{opt.statusName}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

            </div>



            <div fxLayout="row" fxLayoutAlign="start center" class="field-row">
                <div fxFlex="10" class="col-10">
                    <!-- <mat-icon *ngIf="formInit" class="iconcss" style="margin-bottom: 10px;">thumbs_up_down</mat-icon> -->
                </div>
                <div fxFlex="70" class="col-70">
                    <div *ngIf="formInit" fxFlex>

                        <simple-dynamic-form [layout]="2" [formValue]="patchValues"
                            [status]="firstFormGroup.value.LeadStatus" [type]="2" (submit)="onFormSubmitted($event)"
                            [fields]="regConfig">

                        </simple-dynamic-form>

                    </div>

                </div>

            </div>

            <div fxLayout="row" fxLayoutAlign="start center" class="field-row">
                <div fxFlex="10" class="col-10">
                    <mat-icon class="iconcss" style="margin-bottom: 20px;">note</mat-icon>
                </div>
                <div fxFlex="70" class="col-70">
                    <mat-form-field appearance="outline" style="width: 100%;">
                        <mat-label>Remarks</mat-label>
                        <textarea [attr.guide]="'popup-leadstatus-sel-remarks-1' + '__' + sanitizeUrl(url)" trim="blur" matTextareaAutosize matAutosizeMinRows=1 matAutosizeMaxRows=5 matInput
                            formControlName="remarks"></textarea>
                        <!-- <input [attr.guide]="'popup-leadstatus-inp-remarks-1' + '__' + sanitizeUrl(url)" matInput formControlName="remarks"/> -->
                    </mat-form-field>
                </div>
            </div>

            <div fxLayout="row"  *ngIf="currentStatusName != 'Not intrested'"  fxLayoutAlign="start center" class="field-row">
                <div fxFlex="10" class="col-10">
                    <mat-icon class="iconcss" style="margin-bottom: 20px;">update</mat-icon>
                </div>
                <div fxFlex="70" class="col-70" fxLayout="row" fxLayoutGap="10px" style="gap: 10px; width: 100%;">
                    <mat-form-field fxFlex="50" appearance="outline">
                        <mat-label>Follow up Date</mat-label>
                        <input [attr.guide]="'popup-leadstatus-inp-followupdatetime-1' + '__' + sanitizeUrl(url)" required [matDatepicker]="followUp" formControlName="followUpDate" matInput/>
                        <mat-datepicker-toggle [for]="followUp" matSuffix></mat-datepicker-toggle>
                        <mat-datepicker #followUp></mat-datepicker>
                        <mat-error *ngIf="firstFormGroup.get('followUpDate')?.hasError('required')">
                            Please fill out this field.
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field fxFlex="50" appearance="outline">
                        <mat-label>Follow up Time</mat-label>
                        <input [attr.guide]="'popup-leadstatus-inp-followuptime-1' + '__' + sanitizeUrl(url)" type="time" formControlName="followUpTime" matInput/>
                    </mat-form-field>
                </div>
            </div>

        </div>

        <!-- Footer Section -->
        <div fxFlex="none" class="footer-container">
            <div fxLayout="row" fxLayoutAlign="space-between center" class="footer-row">
                <div fxFlex="auto">
                    <!-- <button [attr.guide]="'popup-leadstatus-btn-1-1' + '__' + sanitizeUrl(url)" mat-raised-button color="primary" (click)="checkLeadExist()" class="savechanges">Save
                        Changes</button> -->

                        <button [attr.guide]="'popup-leadstatus-btn-2-1' + '__' + sanitizeUrl(url)" color="primary" (click)="checkLeadExist()" class="savechanges"
                        [disabled]="textSave != 'Save'" mat-raised-button>
                        {{ textSave }}
                        <mat-icon *ngIf="textSave != 'Save'">
                            <mat-spinner color="primary" diameter="20"> </mat-spinner>
                        </mat-icon>
                    </button>
                </div>
                <div fxFlex="none">
                    <button [attr.guide]="'popup-leadstatus-btn-3-1' + '__' + sanitizeUrl(url)" mat-raised-button color="accent" (click)="callclosepopup()" style="width: auto;"
                        class="closebutton">Close</button>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="form-container" [formGroup]="firstFormGroup" *ngIf="popupType == 2">
    <div fxLayout="column" style="height: 100%;">
        <!-- Header -->
        <div fxLayout="row" fxLayoutAlign="space-between center" class="header-row" fxFlex="10">
            <div fxFlex="auto" class="header-text">
                Mark as Priority
            </div>
            <div fxFlex="none">
                <mat-icon (click)="callclosepopup()" style="cursor:pointer;">close</mat-icon>
            </div>
        </div>
        <div fxFlex="10">

        </div>
        <div fxLayout="column" fxFlex="60" class="formfield priority-container">
            <div>
                <h2>Select Priority</h2>
            </div>
            <div fxLayout="row" fxLayoutAlign="center center" fxFlex="100%">


                <div fxLayout="column" fxFlex="30" class="radio-row">
                    <mat-radio-group formControlName="priority">
                        <mat-radio-button [attr.guide]="'popup-leadstatus-chk-4-1' + '__' + sanitizeUrl(url)" class="radio-option" *ngFor="let priority of priorities;let i =index"
                            [value]="priority" (click)="updatePriority(i)">
                            {{ priority }}
                        </mat-radio-button>
                    </mat-radio-group>
                </div>

            </div>
            <div class="submit-section" style="width: 100%;" fxLayout="row" fxLayoutAlign="center center">

                <!-- <button [attr.guide]="'popup-leadstatus-btn-5-1' + '__' + sanitizeUrl(url)" mat-raised-button color="primary" fxFlex (click)="submitone()" class="savechanges">Submit
                </button> -->

                <button [attr.guide]="'popup-leadstatus-btn-6-1' + '__' + sanitizeUrl(url)" color="primary" (click)="submitone()" class="savechanges" [disabled]="text != 'Submit'"
                    mat-raised-button>
                    {{ text }}
                    <mat-icon *ngIf="text != 'Submit'">
                        <mat-spinner color="primary" diameter="20"> </mat-spinner>
                    </mat-icon>
                </button>

            </div>




        </div>

        <!-- Footer Section -->
        <div fxFlex="none" class="footer-container">
            <!-- <div fxLayout="row" fxLayoutAlign="space-between center" class="footer-row">
                <div fxFlex="auto">
                    <button [attr.guide]="'popup-leadstatus-btn-7-1' + '__' + sanitizeUrl(url)" mat-raised-button color="primary" (click)="checkLeadExist()" class="savechanges">Save
                        Changes</button>
                </div>
                <div fxFlex="none">
                    <button [attr.guide]="'popup-leadstatus-btn-8-1' + '__' + sanitizeUrl(url)" mat-raised-button color="accent" (click)="callclosepopup()" style="width: auto;"
                        class="closebutton">Close</button>
                </div>
            </div> -->
        </div>
    </div>
</div>
<div class="form-container" [formGroup]="firstFormGroup" *ngIf="popupType == 3">
    <div fxLayout="column" style="height: 100%;">
        <!-- Header -->
        <div fxLayout="row" fxLayoutAlign="space-between center" class="header-row" fxFlex="10">
            <div fxFlex="auto" class="header-text">
                Update Lead Stage
            </div>
            <div fxFlex="none">
                <mat-icon (click)="callclosepopup()" style="cursor:pointer;">close</mat-icon>
            </div>
        </div>
        <div fxFlex="10">

        </div>
        <div fxFlex="60" class="formfield" style="overflow: scroll;">

            <div fxLayout="row" fxLayoutAlign="start center" class="field-row" style="margin-left: 15px;">
                <div fxFlex="10" class="col-10">
                    <mat-icon class="iconcss" style="margin-bottom: 20px;">thumbs_up_down</mat-icon>
                </div>
                <div fxFlex="70" class="col-70">
                    <mat-form-field appearance="outline" class="my-custom-field" style="width: 100%;" fxFlex>
                        <mat-label class="white-text">Lead Status</mat-label>
                        <mat-select class="white-text" formControlName="LeadStatus" [disableOptionCentering]="true"
                            #singleSelect autocomplete="off">
                            <mat-option>
                                <ngx-mat-select-search name="Lead Status Search" ngDefaultControl
                                    [formControl]="typeYFilterControl" placeholderLabel="Lead Status Search"
                                    [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
                                </ngx-mat-select-search>
                            </mat-option>
                            <mat-option class="white-text"
                             (onSelectionChange)="createDynamicForm($event,opt.dynamicFormGroupId,opt.statusId, opt.statusName)"
                                *ngFor="let opt of filtereddropdownTypeList; let i=index;" [value]="opt.statusId">
                                {{opt.statusName}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

            </div>



            <div fxLayout="row" fxLayoutAlign="start center" class="field-row">
                <div fxFlex="10" class="col-10">
                    <mat-icon *ngIf="formInit" class="iconcss" style="margin-bottom: 20px;">thumbs_up_down</mat-icon>
                </div>
                <div fxFlex="70" class="col-70">

                    <div *ngIf="formInit" fxFlex>

                        <simple-dynamic-form [layout]="2" [formValue]="patchValues"
                            [status]="firstFormGroup.value.LeadStatus" [type]="2" (submit)="onFormSubmitted($event)"
                            [fields]="regConfig">

                        </simple-dynamic-form>

                    </div>

                </div>

            </div>
        </div>

        <!-- Footer Section -->
        <div fxFlex="none" class="footer-container">
            <div fxLayout="row" fxLayoutAlign="space-between center" class="footer-row">
                <div fxFlex="auto">
                    <!-- <button [attr.guide]="'popup-leadstatus-btn-9-1' + '__' + sanitizeUrl(url)" mat-raised-button color="primary" (click)="checkLeadExist()" class="savechanges">Save
                        Changes</button> -->

                    <button [attr.guide]="'popup-leadstatus-btn-10-1' + '__' + sanitizeUrl(url)" color="primary" (click)="checkLeadExist()" class="savechanges"
                        [disabled]="textSave != 'Save'" mat-raised-button>
                        {{ textSave }}
                        <mat-icon *ngIf="textSave != 'Save'">
                            <mat-spinner color="primary" diameter="20"> </mat-spinner>
                        </mat-icon>
                    </button>
                </div>
                <div fxFlex="none">
                    <button [attr.guide]="'popup-leadstatus-btn-11-1' + '__' + sanitizeUrl(url)" mat-raised-button color="accent" (click)="callclosepopup()" style="width: auto;"
                        class="closebutton">Close</button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="form-container" [formGroup]="firstFormGroup" *ngIf="popupType == 4">
    <div fxLayout="column" style="height: 100%;">
        <!-- Header -->
        <div fxLayout="row" fxLayoutAlign="space-between center" class="header-row" fxFlex="10">
            <div fxFlex="auto" class="header-text">
                Update Lead
            </div>
            <div fxFlex="none">
                <mat-icon (click)="callclosepopup()" style="cursor:pointer;">close</mat-icon>
            </div>
        </div>
        <div fxFlex="10">

        </div>
        <div fxFlex="60" class="formfield">

            <div fxLayout="row" fxLayoutAlign="start center" class="field-row">
                <div fxFlex="10" class="col-10">
                    <mat-icon class="iconcss" style="margin-bottom: 20px;">note</mat-icon>
                </div>
                <div fxFlex="70" class="col-70">
                    <mat-form-field appearance="outline" style="width: 100%;">
                        <mat-label>Remarks</mat-label>
                        <textarea [attr.guide]="'popup-leadstatus-sel-remarks-1' + '__' + sanitizeUrl(url)" trim="blur" matTextareaAutosize matAutosizeMinRows=1 matAutosizeMaxRows=5 matInput
                            formControlName="remarks"></textarea>
                        <!-- <input [attr.guide]="'popup-leadstatus-inp-remarks-1' + '__' + sanitizeUrl(url)" matInput formControlName="remarks"/> -->
                    </mat-form-field>
                </div>
            </div>

        </div>

        <!-- Footer Section -->
        <div fxFlex="none" class="footer-container">
            <div fxLayout="row" fxLayoutAlign="space-between center" class="footer-row">
                <div fxFlex="auto">
                    <button [attr.guide]="'popup-leadstatus-btn-12-1' + '__' + sanitizeUrl(url)" color="primary" (click)="checkLeadExist()" class="savechanges"
                    [disabled]="textSave != 'Save'" mat-raised-button>
                    {{ textSave }}
                    <mat-icon *ngIf="textSave != 'Save'">
                        <mat-spinner color="primary" diameter="20"> </mat-spinner>
                    </mat-icon>
                </button>
                </div>
                <div fxFlex="none">
                    <button [attr.guide]="'popup-leadstatus-btn-13-1' + '__' + sanitizeUrl(url)" mat-raised-button color="accent" (click)="callclosepopup()" style="width: auto;"
                        class="closebutton">Close</button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="form-container" [formGroup]="firstFormGroup" *ngIf="popupType == 5">
    <div fxLayout="column" style="height: 100%;">
        <!-- Header -->
        <div fxLayout="row" fxLayoutAlign="space-between center" class="header-row" fxFlex="10">
            <div fxFlex="auto" class="header-text">
                Update Lead
            </div>
            <div fxFlex="none">
                <mat-icon (click)="callclosepopup()" style="cursor:pointer;">close</mat-icon>
            </div>
        </div>
        <div fxFlex="10">

        </div>
        <div fxFlex="60" class="formfield">

            <div fxLayout="row" *ngIf="currentStatusName != 'Not intrested'" fxLayoutAlign="start center" class="field-row">
                <div fxFlex="10" class="col-10">
                    <mat-icon class="iconcss" style="margin-bottom: 20px;">update</mat-icon>
                </div>
                <div fxFlex="70" class="col-70" fxLayout="row" fxLayoutGap="10px" style="gap: 10px; width: 100%;">
                    <mat-form-field fxFlex="50" appearance="outline">
                        <mat-label>Follow up Date</mat-label>
                        <input [attr.guide]="'popup-leadstatus-inp-followupdatetime-5' + '__' + sanitizeUrl(url)" required [matDatepicker]="followUp5" formControlName="followUpDate" matInput/>
                        <mat-datepicker-toggle [for]="followUp5" matSuffix></mat-datepicker-toggle>
                        <mat-datepicker #followUp5></mat-datepicker>
                        <mat-error *ngIf="firstFormGroup.get('followUpDate')?.hasError('required')">
                            Please fill out this field.
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field fxFlex="50" appearance="outline">
                        <mat-label>Follow up Time</mat-label>
                        <input [attr.guide]="'popup-leadstatus-inp-followuptime-5' + '__' + sanitizeUrl(url)" type="time" formControlName="followUpTime" matInput/>
                    </mat-form-field>
                </div>
            </div>

        </div>

        <!-- Footer Section -->
        <div fxFlex="none" class="footer-container">
            <div fxLayout="row" fxLayoutAlign="space-between center" class="footer-row">
                <div fxFlex="auto">
                    <button [attr.guide]="'popup-leadstatus-btn-14-1' + '__' + sanitizeUrl(url)" color="primary" (click)="checkLeadExist()" class="savechanges"
                    [disabled]="textSave != 'Save'" mat-raised-button>
                    {{ textSave }}
                    <mat-icon *ngIf="textSave != 'Save'">
                        <mat-spinner color="primary" diameter="20"> </mat-spinner>
                    </mat-icon>
                </button>
                </div>
                <div fxFlex="none">
                    <button [attr.guide]="'popup-leadstatus-btn-15-1' + '__' + sanitizeUrl(url)" mat-raised-button color="accent" (click)="callclosepopup()" style="width: auto;"
                        class="closebutton">Close</button>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="form-container" [formGroup]="firstFormGroup" *ngIf="popupType == 6">
    <div fxLayout="column" style="height: 100%;">
        <!-- Header -->
        <div fxLayout="row" fxLayoutAlign="space-between center" class="header-row" fxFlex="10">
            <div fxFlex="auto" class="header-text">
                Update Lead Notes
            </div>
            <div fxFlex="none">
                <mat-icon (click)="callclosepopup()" style="cursor:pointer;">close</mat-icon>
            </div>
        </div>
        <div fxFlex="10">

        </div>
        <div fxFlex="60" class="formfield">

            <div fxLayout="row" fxLayoutAlign="start center" class="field-row">
                <div fxFlex="10" class="col-10">
                    <mat-icon class="iconcss" style="margin-bottom: 20px;">note</mat-icon>
                </div>
                <div fxFlex="70" class="col-70">
                    <mat-form-field appearance="outline" style="width: 100%;">
                        <mat-label>Notes</mat-label>
                        <textarea [attr.guide]="'popup-leadstatus-sel-branch-1' + '__' + sanitizeUrl(url)" trim="blur" matTextareaAutosize matAutosizeMinRows=1 matAutosizeMaxRows=5 matInput
                            formControlName="branch"></textarea>
                    </mat-form-field>
                </div>
            </div>

        </div>

        <!-- Footer Section -->
        <div fxFlex="none" class="footer-container">
            <div fxLayout="row" fxLayoutAlign="space-between center" class="footer-row">
                <div fxFlex="auto">
                    <button [attr.guide]="'popup-leadstatus-btn-16-1' + '__' + sanitizeUrl(url)" color="primary" (click)="checkLeadExist()" class="savechanges"
                    [disabled]="textSave != 'Save'" mat-raised-button>
                    {{ textSave }}
                    <mat-icon *ngIf="textSave != 'Save'">
                        <mat-spinner color="primary" diameter="20"> </mat-spinner>
                    </mat-icon>
                </button>
                </div>
                <div fxFlex="none">
                    <button [attr.guide]="'popup-leadstatus-btn-17-1' + '__' + sanitizeUrl(url)" mat-raised-button color="accent" (click)="callclosepopup()" style="width: auto;"
                        class="closebutton">Close</button>
                </div>
            </div>
        </div>
    </div>
</div>
